import * as React from "react";

export const AppContext = React.createContext({
  renderMacrons: false,
  toggleMacrons: () => {}
})